import { useState } from 'react';
import { toast } from 'sonner';
import legalRepresentativeServices from '../api/legalRepresentativeServices';

export const useRemoveRepresentative = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const removeRepresentative = async (params) => {
    setIsLoading(true);
    setError(null);
    
    try {
      const result = await legalRepresentativeServices.removeRepresentative(params);
      
      if (result.success) {
        // Message de succès complet avec infos du backend
        const { data } = result;
        
        let successMessage = result.message;
        let details = null;
        
        if (data.accountUpdated && data.emailUpdated) {
          details = `Compte converti en non-administré • Email: ${data.currentEmail || 'N/A'}`;
        } else if (data.accountUpdated && data.requiresEmail) {
          details = `Compte converti en non-administré • Email requis`;
        } else if (data.accountUpdated) {
          details = `Compte converti en non-administré`;
        }
        
        if (details) {
          toast.success(
            <div>
              <div className="fw-bold">{successMessage}</div>
              <small className="text-muted">{details}</small>
            </div>,
            { duration: 6000 }
          );
        } else {
          toast.success(successMessage, { duration: 5000 });
        }
        
        return result;
      } else {
        throw new Error(result.message || 'Échec de la dissociation');
      }
    } catch (error) {
      const errorMessage = error.message;
      setError(errorMessage);
      
      // Messages d'erreur contextuels
      if (errorMessage.includes('Email déjà utilisé')) {
        toast.error(
          <div>
            <div className="fw-bold">Email déjà utilisé</div>
            <small className="text-muted">Cet email est déjà associé à un autre compte.</small>
          </div>,
          { duration: 8000 }
        );
      } else if (errorMessage.includes('Aucun mandataire')) {
        toast.warning(errorMessage, { duration: 5000 });
      } else {
        toast.error(
          <div>
            <div className="fw-bold">Échec de l'opération</div>
            <small className="text-muted">{errorMessage}</small>
          </div>,
          { duration: 8000 }
        );
      }
      
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    removeRepresentative,
    isLoading,
    error,
    resetError: () => setError(null)
  };
};